import React from 'react';
import { IconButton, Stack, Tooltip } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import EditIcon from '@mui/icons-material/Edit';
import { useTranslation } from 'react-i18next';

const iconButtonSx = (checked, disabled) => ({
  width: 34,
  height: 34,
  border: '1px solid',
  borderColor: disabled
    ? 'rgba(148, 163, 184, 0.22)'
    : checked
      ? 'rgba(87, 87, 176, 0.55)'
      : 'rgba(148, 163, 184, 0.35)',
  backgroundColor: disabled
    ? 'rgba(148, 163, 184, 0.05)'
    : checked
      ? 'rgba(87, 87, 176, 0.12)'
      : 'transparent',
  color: disabled
    ? 'rgba(148, 163, 184, 0.75)'
    : checked
      ? '#373f8c'
      : 'rgba(71, 85, 105, 0.8)',
  '&:hover': {
    backgroundColor: disabled
      ? 'rgba(148, 163, 184, 0.05)'
      : checked
        ? 'rgba(87, 87, 176, 0.18)'
        : 'rgba(148, 163, 184, 0.08)'
  }
});

const PublicAccessPermissionIcons = ({
  accessFlags,
  disabled = false,
  onToggleView,
  onToggleUpload
}) => {
  const { t } = useTranslation();

  const buttons = [
    {
      key: 'view',
      checked: Boolean(accessFlags?.canView),
      disabled,
      onClick: onToggleView,
      tooltip: t('project_share.view_only', 'View only'),
      icon: <VisibilityIcon fontSize="small" />
    },
    {
      key: 'upload',
      checked: Boolean(accessFlags?.canUpload),
      disabled,
      onClick: onToggleUpload,
      tooltip: t('project_share.upload_only', 'Upload only'),
      icon: <UploadFileIcon fontSize="small" />
    },
    {
      key: 'edit',
      checked: false,
      disabled: true,
      onClick: undefined,
      tooltip: t('project_share.public_edit_not_available', 'Edit is not available for public access'),
      icon: <EditIcon fontSize="small" />
    }
  ];

  return (
    <Stack direction="row" spacing={0.75} alignItems="center">
      {buttons.map((button) => (
        <Tooltip key={button.key} title={button.tooltip} arrow enterDelay={180}>
          <span>
            <IconButton
              size="small"
              disabled={button.disabled}
              onClick={button.onClick}
              aria-pressed={button.checked}
              aria-label={button.tooltip}
              sx={iconButtonSx(button.checked, button.disabled)}
            >
              {button.icon}
            </IconButton>
          </span>
        </Tooltip>
      ))}
    </Stack>
  );
};

export default PublicAccessPermissionIcons;
